import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";

import axios from "axios";
import SelectListComponent from "../SelectListComponent";
import { globalConfig } from "../../../config/config";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";
// const querystring = require("querystring");

const CreateContentAssociations = () => {
  const [message, setMessage] = useState("");
//   const { currentContentObject } = useContentObjectContext();
  const [contentAssociationTypes, setContentAssociationTypes] = useState([]);
//   const {token,userMetadata}=useAuth()
	const token = globalConfig.hardcoded_header;
//   const history = useHistory();
  const [state, setState] = useState({
    contentAssociationId: 0,
    contentId: 0, //currentContentObject,
    contentAssociationTypeId: 0,
    contentAssociationName: "",
    contentAssociationDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-associations`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-associations/contentAssociationId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentAssociationId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentAssociationId
          );
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({
        ...state,
        contentAssociationName: "",
        contentAssociationDescr: "",
        contentObjectName: "",
      });
    })
    .catch((x) => {
    });

    //   console.log("SetState Message info-"+this.contentFacadeTypeId);
    //   console.log("SetState Message info-"+this.contentFacadeName);
  }
  function handleRest() {
    setState({
      ...state,
      contentAssociationName: "",
      contentAssociationDescr: "",
      contentObjectName: "",
    });
  }

  // componentDidMount()
  // {
  // 	this.handleOnLoad();
  // }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-association-types`,
         apiHeader(token)
      )
      .then((res) => {
        const contentAssociationTypes = res.data;
        console.log(contentAssociationTypes);
        setContentAssociationTypes(contentAssociationTypes);
      })
      .catch((x) => {
      });
  };
  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Assocaiation</h4>			
			<Link to="/breeze/list-content-associations">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            id="contentId"
            readOnly={true}
            id="content_name"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Association Type">
            Associations Type
          </label>
          <select
            id="contentAssociationTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeId}
            onChange={handleChange}
          >
            <option>Select Association Type</option>
            {contentAssociationTypes.map(
              ({ contentAssociationTypeName, contentAssociationTypeId }) => (
                <option
                  key={contentAssociationTypeId}
                  value={contentAssociationTypeId}
                >
                  {contentAssociationTypeName}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Association Object">
            Association Object Name
          </label>
          <input
            id="contentAssociationName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentAssociationDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationDescr}
            onChange={handleChange}
          >
            {" "}
          </textarea>
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentAssociations;
